import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"
import type { TypedSchemaOutput } from "@/utils/utilityTypes"

const createUpdateCashierFormSchema = z.object({
  username: z.string(),
  color: z.string().nullable(),
  pin: z
    .string()
    .length(4, { message: "Pin must be 4 characters long" })
    .regex(/\d+/, {
      message: "Pin must only contain numeric characters",
    })
    .nullable(),
})

export type CreateUpdateCashierFormOutput =
  TypedSchemaOutput<typeof createUpdateCashierFormSchema>

export const useCreateUpdateCashierForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createUpdateCashierFormSchema
    ),
    initialValues: {
      username: "",
      color: null,
      pin: null,
    },
  })
